import React from 'react';

/**
 * Nothing to mount on the desktop and web builds: the desktop opens a window of
 * its own and the web build refuses the flow. The phones replace this file with
 * `SpotifyAuthWebView.native.tsx`, which hosts the real web view.
 */
export const SpotifyAuthWebView: React.FC = () => null;
